



















import { resolveTemplateButtonIcon } from "@/utils/templates";
import { defineComponent } from "@vue/composition-api";
import { BButton } from "bootstrap-vue";

export default defineComponent({
    components: {
        BButton,
    },
    props: {
        buttons: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const getUrl = (button): string => {
            if (button.type !== "URL") {
                return;
            }

            if (!button.dynamic) {
                return button.url;
            }

            let index = 0;

            return button.url.replace(/\{\{[^}]+}}/g, (match) => button.variables?.[index++]?.value ?? match);
        };

        return {
            resolveTemplateButtonIcon,
            getUrl,
        };
    },
});
